import { useAppDispatch, useAppSelector } from '@/app/store/hooks';
import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import {
  closeFeedBackModal,
  ModalFeedbackType,
  selectModalFeedbackLink,
  selectModalFeedbackType,
  selectModalOpened,
} from '../model/slice';
import { Feedback } from '@/features/feedback/ui/Feedback';

export type FeedbackContentType = {
  title: string;
  description?: string;
};

const contentMap: Record<ModalFeedbackType, FeedbackContentType> = {
  application: {
    title: 'Оставьте заявку на консультацию',
  },
  presentation: {
    title: 'Загрузите презентацию KRASOTA TOWER',
    description:
      'Наш эксперт свяжется с вами в ближайшее время, что бы подобрать подходящую недвижимость или ответить на интересующие вопросы',
  },
  selection: {
    title: 'Получите эксклюзивную подборку',
    description:
      'Оставьте свои контактные данные, чтобы получить доступ к нашей уникальной подборке топовых объектов. Выберите удобный способ скачивания, и презентация будет доступна в считанные минуты',
  },
};

export interface ModalFeedbackProps {}

export const ModalFeedback = ({}: ModalFeedbackProps) => {
  const overlayRef = useRef<HTMLDivElement>(null);
  const dispatch = useAppDispatch();

  const opened = useAppSelector(selectModalOpened);
  const type = useAppSelector(selectModalFeedbackType);
  const link = useAppSelector(selectModalFeedbackLink);

  const downloadByLink = (link: string, filename?: string) => {
    if (!link) return;

    const a = document.createElement('a');
    a.href = link;
    a.target = '_blank';
    a.rel = 'noopener noreferrer';

    if (filename) {
      a.download = filename;
    }

    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  useEffect(() => {
    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        dispatch(closeFeedBackModal());
      }
    };

    if (opened) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [opened]);

  const handleOverlayClick = (event: React.MouseEvent) => {
    if (event.target === overlayRef.current) {
      dispatch(closeFeedBackModal());
    }
  };

  const handleCloseModal = () => {
    dispatch(closeFeedBackModal());
  };

  if (!opened) return null;

  return createPortal(
    <div className="fixed inset-0 z-20 flex items-center justify-center bg-black/70">
      <div
        ref={overlayRef}
        className="container px-[10px] md:px-[32px] 2xl:px-[180px] 3xl:px-[290px]"
        onClick={handleOverlayClick}
      >
        <Feedback
          content={type && contentMap[type]}
          isModal={true}
          link={link || ''}
          handlModalClose={handleCloseModal}
          handleDataSend={() => downloadByLink(link || '', 'presentation.pdf')}
        />
      </div>
    </div>,
    document.body
  );
};
